import { type ReactNode } from 'react'

export const dKey = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

export function BarChart({ daily }: { daily: Record<string, number> }) {
  const days: { k: string; v: number }[] = []
  for (let i = 29; i >= 0; i--) {
    const d = new Date(); d.setDate(d.getDate() - i)
    const k = dKey(d)
    days.push({ k, v: daily[k] || 0 })
  }
  const max = Math.max(10, ...days.map((x) => x.v))
  const W = 720, H = 160, pad = 22, bw = (W - pad * 2) / days.length
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block' }}>
      <line x1={pad} y1={H - pad} x2={W - pad} y2={H - pad} stroke="#e7ebf2" />
      {days.map((x, i) => {
        const h = (x.v / max) * (H - pad * 2)
        return <rect key={i} x={pad + i * bw + 1} y={H - pad - h} width={bw - 2} height={h} rx={2} fill="#5b7cfa" opacity={0.85}><title>{`${x.k}: ${x.v} 分`}</title></rect>
      })}
      {days.map((x, i) => i % 5 === 0 ? (
        <text key={'t' + i} x={pad + i * bw + bw / 2} y={H - 6} textAnchor="middle" fill="#707d90" fontSize={9}>{x.k.slice(5)}</text>
      ) : null)}
    </svg>
  )
}

export function Heatmap({ daily }: { daily: Record<string, number> }) {
  const weeks = 13, cell = 15, gap = 3
  const end = new Date(); end.setDate(end.getDate() + (6 - ((end.getDay() + 6) % 7)))
  const max = Math.max(1, ...Object.values(daily))
  const color = (v: number) => {
    if (!v) return '#e7ebf2'
    const t = v / max
    return t > 0.75 ? '#1d7a44' : t > 0.5 ? '#2ec16b' : t > 0.25 ? '#7fd9a3' : '#bdeccd'
  }
  const rects: ReactNode[] = []
  for (let w = weeks - 1; w >= 0; w--) {
    for (let d = 0; d < 7; d++) {
      const dt = new Date(end); dt.setDate(end.getDate() - w * 7 + (d - 6))
      const k = dKey(dt); const v = daily[k] || 0
      rects.push(<rect key={`${w}-${d}`} x={(weeks - 1 - w) * (cell + gap)} y={d * (cell + gap)} width={cell} height={cell} rx={2} fill={color(v)}><title>{`${k}: ${v} 分`}</title></rect>)
    }
  }
  const W = weeks * (cell + gap), H = 7 * (cell + gap)
  return (
    <div>
      <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H}>{rects}</svg>
      <div className="text-[#707d90] text-[13px] mt-1.5 flex items-center gap-1">
        少
        <span className="inline-block w-3 h-3 rounded-sm" style={{ background: '#e7ebf2' }} />
        <span className="inline-block w-3 h-3 rounded-sm" style={{ background: '#7fd9a3' }} />
        <span className="inline-block w-3 h-3 rounded-sm" style={{ background: '#1d7a44' }} />
        多
      </div>
    </div>
  )
}
